import {
  contextIsAvailable,
  extractTrackingPageContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import { StoryDetailPageContext } from '@aboutyou/legacy-tracking-sdk'
import { exists } from 'helpers/exists'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useTrackingCustomer } from 'helpers/tracking/trackerComponents/TrackCustomer'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import { useStoryPageStore } from 'store/context'

export function useTrackStoryPageView(pageTitle: string) {
  const { pageContext, TrackingClient } = useTracking()
  const storyPageStore = useStoryPageStore()
  const story = useObserver(() => storyPageStore.story)
  const customer = useTrackingCustomer()
  const tracked = useRef(false)
  const {
    location: { pathname },
  } = useHistory()

  useEffect(() => {
    if (tracked.current) {
      return
    }

    if (
      exists(customer) &&
      story &&
      contextIsAvailable(pageContext) &&
      !pageContext.disabled &&
      Number(story.id) === pageContext.id &&
      // Makes sure to track the content view only when the pageContext has the info for the correct path, since the redial send the info for the new page delayed
      pathname === pageContext.path
    ) {
      const page = extractTrackingPageContext(pageContext)

      tracked.current = true
      TrackingClient?.trackStoryView({
        page: { ...page, title: pageTitle } as StoryDetailPageContext,
        customer,
      })
    }
  }, [pageContext, exists(story), pageTitle, customer?.type])
}

const TrackStoryPageView: FC<
  React.PropsWithChildren<{ pageTitle: string }>
> = ({ pageTitle, children }) => {
  useTrackStoryPageView(pageTitle)

  return <>{children}</>
}

export default TrackStoryPageView
